@if (loading) {
  <div class="external-search">
    <p class="external-search-loading">
      <mat-icon>travel_explore</mat-icon> {{ 'externalSearch.loading' | t }}
    </p>
  </div>
} @else if (results.length > 0 || links.length > 0) {
  <section class="external-search">
    <h2 class="external-search-title">{{ 'externalSearch.title' | t }}</h2>
    @if (results.length > 0) {
      <p class="external-search-subtitle">{{ 'externalSearch.subtitle' | t: { query: searchedQuery } }}</p>
      <div class="external-search-grid">
        @for (result of results; track result.network + result.externalId) {
          <a class="external-search-card" [href]="result.affiliateUrl" target="_blank" rel="sponsored noopener">
            <div class="external-search-picture">
              @if (result.pictureUrl && !brokenPictures.has(result.pictureUrl)) {
                <img [src]="result.pictureUrl" [alt]="result.name" loading="lazy" (error)="brokenPictures.add(result.pictureUrl)">
              } @else {
                <mat-icon class="external-search-no-picture">image</mat-icon>
              }
              @if (result.percentageDiscount) {
                <span class="external-search-discount">-{{ result.percentageDiscount }}%</span>
              }
            </div>
            <span class="external-search-merchant">{{ result.merchant }}</span>
            <span class="external-search-name">{{ result.name }}</span>
            <div class="external-search-prices">
              @if (result.priceDiscount) {
                <span class="external-search-price">{{ result.priceDiscount | number: '1.2-2' }}€</span>
              }
              @if (result.price && result.price != result.priceDiscount) {
                <span class="external-search-old-price">{{ result.price | number: '1.2-2' }}€</span>
              }
            </div>
            <span class="external-search-button">{{ 'deals.seeOffer' | t }}</span>
          </a>
        }
      </div>
    }
    @if (links.length > 0) {
      <div class="external-search-links">
        @for (link of links; track link.url) {
          <a class="external-search-link" [href]="link.url" target="_blank" rel="sponsored noopener">
            <mat-icon>search</mat-icon>
            {{ 'externalSearch.seeOn' | t: { query: searchedQuery, merchant: link.label } }}
          </a>
        }
      </div>
    }
    <p class="external-search-disclosure">{{ 'externalSearch.disclosure' | t }}</p>
  </section>
}
